import { render } from "./PageHead.vue?vue&type=template&id=46719d59&scoped=true"
import script from "./PageHead.vue?vue&type=script&lang=js"
export * from "./PageHead.vue?vue&type=script&lang=js"

import "./PageHead.vue?vue&type=style&index=0&id=46719d59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46719d59"]])

export default __exports__